import script from "./UserGroupForm.vue?vue&type=script&setup=true&lang=js"
export * from "./UserGroupForm.vue?vue&type=script&setup=true&lang=js"

import "./UserGroupForm.vue?vue&type=style&index=0&id=5c9a9b9f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c9a9b9f"]])

export default __exports__